<template>
  <div id="app">
    <transition
        name="fade"
        mode="out-in"
      >
      <router-view></router-view>
    </transition> 
  </div>
</template>

<script>
  export default {
    name: 'invoce-system'
  }
</script>

<style lang="scss">
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>